<template>
  <div class="tab-content">
    <el-form
      v-for="(fields, moduleName) in modules"
      :key="moduleName"
      :ref="`${moduleName}Form`"
      size="medium"
      label-width="200px"
    >
      <template v-if="fields">
        <h2 class="column-title">{{ $t(`content.${moduleName}`) }}</h2>
        <div
          v-for="(field, key, index) in fields"
          :key="`${tabId}-${key}-${index}`"
        >
          <component
            :is="getComponentType(field.type)"
            :zdId="getZdId(field, index)"
            :shelflifeNumber="shelflifeNumber"
            :pageStatus="pageStatus"
            @update:shelflifeNumber="updateShelflifeNumber"
          />
        </div>
      </template>
    </el-form>
    <!-- 操作按钮 -->
    <div v-if="showOptionButton('spec')">
      <ZDSpecNote :zdId="getZdId('spec-note', 0)"></ZDSpecNote>
      <ZDSpecOptionButton
        @save="saveValueHandle"
        :zdId="getZdId('spec-option-button', 0)"
        :pageStatus="pageStatus"
      ></ZDSpecOptionButton>
    </div>
    <div v-if="showOptionButton('coa')">
      <ZDSpecNote :zdId="getZdId('coa-notes', 0)"></ZDSpecNote>
      <ZDCoaOptionButton
        @save="saveValueHandle"
        :zdId="getZdId('coa-option-button', 0)"
        :tabId="tabId"
      ></ZDCoaOptionButton>
    </div>
  </div>
</template>

<script>
import ZDInput from "./zd-modules/ZDInput";
import ZDSelect from "./zd-modules/ZDSelect";
import ZDCheckBox from "./zd-modules/ZDCheckBox.vue";
import ZDTag from "./zd-modules/ZDTag.vue";
import ZDTextarea from "./zd-modules/ZDTextarea.vue";
import ZDCustomInput from "./zd-modules/ZDCustomInput.vue";
import ZDTwoColumnInput from "./zd-modules/ZDTwoColumnInput.vue";
import ZDTwoColumnCustomInput from "./zd-modules/ZDTwoColumnCustomInput.vue";
import ZDSpecOptionButton from "./zd-modules/ZDSpecOptionButton.vue";
import ZDRevisionComponents from "./zd-modules/ZDRevisionComponents.vue";
import ZDCoaOptionButton from "./zd-modules/ZDCoaOptionButton.vue";
import ZDDate from "./zd-modules/ZDDate.vue";
import ZDThreeInput from "./zd-modules/ZDThreeInput.vue";
import ZDThreeCustomInput from "./zd-modules/ZDThreeCustomInput.vue";
import ZDSpecNote from "./zd-modules/ZDSpecNote.vue";
import ZDCoaNote from "./zd-modules/ZDCoaNote.vue";
import ZDNotesText from "./zd-modules/ZDNotesText.vue";
import ZDAutoInput from "./zd-modules/ZDAutoInput.vue";
import ZDAutoInputDescription from "./zd-modules/ZDAutoInputDescription.vue";
import { mapActions, mapGetters } from "vuex";

import * as TemplateUtils from "../template/index";

export default {
  props: {
    modules: {
      type: Object,
      required: true,
    },
    tabId: {
      type: [String, Number],
      required: true,
    },
    shelflifeNumber: {
      type: Number,
      default: 24,
    },
    pageStatus: {
      type: String,
      default: "Add", // 默认值为Add，与PanelDetail的初始状态保持一致
    },
  },
  components: {
    ZDInput,
    ZDSelect,
    ZDCheckBox,
    ZDTag,
    ZDTextarea,
    ZDCustomInput,
    ZDTwoColumnInput,
    ZDTwoColumnCustomInput,
    ZDRevisionComponents,
    ZDSpecOptionButton,
    ZDCoaOptionButton,
    ZDDate,
    ZDThreeInput,
    ZDThreeCustomInput,
    ZDSpecNote,
    ZDCoaNote,
    ZDNotesText,
    ZDAutoInput,
    ZDAutoInputDescription,
  },
  provide() {
    return {
      getModulesDataMethod: this.getModulesData,
    };
  },
  inject: [
    "getNotesDataMethod",
    "getCurrentDataMethod",
    "getNotesConfigMethod",
    "getCustomNotesMethod"
  ],
  computed: {
    ...mapGetters("zdInput", ["getComponentState"]),
    getZdId() {
      return (field, idx) => {
        let key = field;
        if (field.label) {
          key = field.label.toLowerCase().replaceAll(" ", "_");
        }
        
        if(!field.type){
          // console.info("field===>:",field)
          field={}
          field.type = "input"
          if(field=="coa-note"){
            // console.info("modules===>:",this.modules)
            // console.info("key===>:",key)
            field=this.modules.other_notes.notes;
            // console.info("field111===>:",field)
          }

        }
        // console.info('field.type:',field.type)
        let zId = `${this.tabId}_${key}_id_${field.type}_${idx}`;
        // console.info("zId88:",zId)
        return zId;
      };
    },
    showOptionButton() {
      return (category) => {
        let type = this.$route.query.type;
        return category == type;
      };
    },
  },
  data() {
    return {};
  },
  created() {
    // console.info("modules:", this.modules);
    // this.initializeComponents();
    
    // 监听标签页变化事件
    this.$EventBus.$on("tabChanged", this.handleTabChanged);
    this.$EventBus.$on("pageStatusChange", this.handlePageStatusChange);
    
    // 修复：初始化时检查当前页面状态，确保组件状态正确
    this.$nextTick(() => {
      const currentPageStatus = this.pageStatus;
      const currentTabName = localStorage.getItem("currentTabName"); // currentTabName 仍然从 localStorage 获取
      // console.info("currentPageStatus:",currentPageStatus)
      // console.info("currentTabName:",currentTabName)
      if (currentPageStatus && currentTabName) {
        // console.info("ZDComponents: Initial state check - pageStatus:", currentPageStatus, "tabName:", currentTabName);
        
        // 根据当前状态设置组件编辑状态
        this.updateComponentsEditState(currentPageStatus);
      }
    });
  },
  
  beforeDestroy() {
    // 清理事件监听器
    this.$EventBus.$off("tabChanged", this.handleTabChanged);
    this.$EventBus.$off("pageStatusChange", this.handlePageStatusChange);
  },
  watch: {
    modules: {
      handler() {
        this.initializeComponents();
      },
      deep: true, // 深度监听
      immediate: true, // 立即执行一次
    },
  },
  methods: {
    ...mapActions("zdInput", ["initializeComponent"]),
    
    /**
     * 处理标签页变化
     */
    handleTabChanged(data) {
      // console.info("ZDComponents: Tab changed to", data.tabName, "with status", data.pageStatus);
      
      // 根据页面状态重新设置组件的编辑状态
      this.updateComponentsEditState(data.pageStatus);
    },
    
    /**
     * 处理页面状态变化
     */
    handlePageStatusChange(pageStatus) {
      // console.info("ZDComponents: Page status changed to", pageStatus);
      
      // 根据页面状态重新设置组件的编辑状态
      this.updateComponentsEditState(pageStatus);
    },
    
    /**
     * 根据页面状态更新组件的编辑状态
     */
    updateComponentsEditState(pageStatus) {
      // 延迟执行，确保组件状态已经更新
      this.$nextTick(() => {
        for (let module in this.modules) {
          for (let key in this.modules[module]) {
            const field = this.modules[module][key];
            const idx = Object.keys(this.modules[module]).indexOf(key);
            const zId = this.getZdId(field, idx);
            
            // 获取当前组件状态
            const currentState = this.getComponentState(zId);
            if (currentState) {
              // 根据页面状态设置disabled属性
              let shouldDisable = false;
              
              if (pageStatus === "Detail") {
                // 详情页：所有字段都不可编辑
                shouldDisable = true;
              } else if (pageStatus === "Edit") {
                // 编辑页：根据字段配置决定是否可编辑
                shouldDisable = field.disabled || false;
              }
              
              // 更新组件的disabled状态
              this.initializeComponent({
                id: zId,
                data: {
                  ...currentState,
                  disabled: shouldDisable
                }
              });
            }
          }
        }
      });
    },
    
    getModulesData() {
      return this.modules;
    },
    // 动态获取控件类型
    getComponentType(type) {
      const types = {
        select: "ZDSelect",
        input: "ZDInput",
        textarea: "ZDTextarea",
        checkbox: "ZDCheckBox",
        tag: "ZDTag",
        custom_input: "ZDCustomInput",
        two_column_input: "ZDTwoColumnInput",
        two_column_custom_input: "ZDTwoColumnCustomInput",
        rev: "ZDRevisionComponents",
        date: "ZDDate",
        three_input: "ZDThreeInput",
        three_custom_input: "ZDThreeCustomInput",
        auto_input: "ZDAutoInput",
        auto_input_description: "ZDAutoInputDescription",
      };
      return types[type] || "div";
    },
    /**
     * 初始化所有 ZDInput 组件的状态
     */
    initializeComponents() {
      // console.info("initializeComponents111111:");
      for (let module in this.modules) {
        for (let key in this.modules[module]) {
          const field = this.modules[module][key];
          const idx = Object.keys(this.modules[module]).indexOf(key);
          const zId = this.getZdId(field, idx);

          // console.info("zId:", zId);
          // console.info("field :", field );
          // console.info("field:", field.value instanceof Array);
          const initData = {
            id: zId,
            data: {
              ...field,
              // rev 类型需要数组，其他类型用字符串兜底
              value: (field.type === 'rev')
                ? (Array.isArray(field.value) ? field.value : [])
                : (field.value || ""),
              disabled: this.pageStatus === 'Detail' ? true : (this.pageStatus === 'Edit' ? (field.disabled || false) : false),
            },
          };
          let notesIdFlag = zId.indexOf("tab1_notes_id_input_")!=-1
          // console.info("zId9999:",notesIdFlag)
          if(notesIdFlag){
            // console.info("initData:",initData)
          }
          
          // 修复：处理notes字段的数组转换逻辑
          if(field.value instanceof Array && notesIdFlag){
            // console.info("重设 value")
            initData.data.value = field.value.join("@$");
            // console.info("重设 initData.value:",initData.data.value)
            // 同时保存原始的数组数据到modules中，以便getNotesDataMethod能正确返回
            this.modules[module][key].originalValue = field.value;
          }
          
          // console.info(initData.data.value)
          // console.info('initData:',initData)
          this.initializeComponent(initData);
        }
      }
    },
    saveHandle() {},
    /**
     * 处理保存仅包含 value 字段的数据
     */
    saveValueHandle(callback) {
      // 深拷贝 modules，避免直接修改 props
      let updatedModules = JSON.parse(JSON.stringify(this.modules));

      // 遍历 updatedModules
      for (let moduleName in updatedModules) {
        let fields = updatedModules[moduleName];

        if (fields) {
          for (let key in fields) {
            const field = fields[key];

            if(key=='custom_field'){
              // 判断空值删除行
              if (fields[key].value && fields[key].value.length >= 1) {
                const tmpArr = fields[key].value.filter((item) => {
                  return item.fields && item.fields.trim().length > 0 && item.value && item.value.trim().length > 0;
                });
                field.value = tmpArr;
              }
            }
            
            const idx = Object.keys(fields).indexOf(key);
            const zId = this.getZdId(field, idx);

            // 从 Vuex 获取最新的组件状态
            const zdItem = this.getComponentState(zId);
            if (zdItem) {
              // 更新字段的 value 值
              field.value = zdItem.value;
              
              // 特殊处理：如果是notes字段，优先使用统一管理的数据
              if (key === 'notes') {
                const customNotes = this.getCustomNotesMethod();
                if (customNotes && customNotes.length > 0) {
                  field.value = customNotes;
                } else if (typeof zdItem.value === 'string' && zdItem.value.includes('@$')) {
                  field.value = zdItem.value.split('@$').filter(function(item) {
                    return item.trim().length > 0;
                  });
                } else if (typeof zdItem.value === 'string' && zdItem.value.trim().length > 0) {
                  field.value = [zdItem.value];
                } else if (!Array.isArray(zdItem.value)) {
                  field.value = [];
                }
              }
            }
          }
        }
      }

      // 提取 value 值
      let data = TemplateUtils.config.templateToValue(updatedModules);
      
      // 添加调试信息：检查 other_notes.notes 的类型
      if (data.other_notes && data.other_notes.notes) {
        console.info('修复后 data.other_notes.notes instanceof Array:', data.other_notes.notes instanceof Array);
        console.info('修复后 data.other_notes.notes:', data.other_notes.notes);
      }

      let type = this.$route.query.type;
      if (type == "coa") {
        // 使用统一的notes配置管理
        const notesConfig = this.getNotesConfigMethod();
        const customNotes = this.getCustomNotesMethod();
        
        data.notes = {
          note1: notesConfig.additionalNotes.note1 || false,
          note2: notesConfig.additionalNotes.note2 || false,
          note3: notesConfig.additionalNotes.note3 || false,
          is_show_note: notesConfig.additionalNotes.is_show_note !== false,
          custom: customNotes || [],
        };
        
        console.info("data666:", data.notes.custom);
      }

      // 执行回调，传递更新后的 modules
      if (callback) {
        callback(data);
      }
    },
    updateShelflifeNumber(newVal) {
      this.$emit('update:shelflifeNumber', newVal);
    }
  },
};
</script>

<style scoped>
@import "../style/new-spec.css";
</style>
